import styled from 'styled-components';
import { Button } from '../../../../ui';

export const StyledChoiceButton = styled(Button)`
  border-radius: 12px;
  flex: 1 1 auto !important;
  width: 100% !important;
`;

export const StyledInfoIconButton = styled.button<{
  title?: string;
}>`
  background-color: transparent;
  border: 0;
  height: 15px;
  width: 15px;

  svg {
    height: 15px;
    width: 15px;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;
